import React from 'react'
import { default as ReactCreatableSelect } from 'react-select/creatable'

const CreatableSelect = ({
  fieldKey,
  updateOptionValue,
  options,
  placeholder = '',
  isMulti = false
}) => {
  return (
    <ReactCreatableSelect
      isClearable
      isMulti={isMulti}
      menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
      menuPosition="fixed"
      styles={{
        menuPortal: base => ({ ...base, zIndex: 9999 })
      }}
      onChange={newValue =>
        updateOptionValue(
          isMulti
            ? (newValue ? newValue.map(item => item.value) : [])
            : (newValue ? newValue.value : ''),
          fieldKey
        )
      }
      options={options.map(value => ({ value, label: value }))}
      placeholder={placeholder}
      menuPortalTarget={document.body}
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 10000 })
      }}
    />
  )
}

export default CreatableSelect